import { createCustomAction } from 'typesafe-actions';

import { AddCreativeAction } from '../AddCreativePage/actions';
import { CanvasAppAction } from '../CanvasApp/actions';
import { ItemNameEditorAction } from '../CanvasEditableLabel/actions';
import { CommonCreativesAction } from '../CommonCreatives/actions';
import { CreativeImageCropModalAction } from '../CreativeImageCropModal/actions';
import { CreativeSmartCenterModalAction } from '../CreativeSmartCenterModal/actions';
import { FileEditorAction } from '../FileEditor/actions';
import { GalleryAction } from '../GalleryPane/actions';
import { Html5Action } from '../Html5App/typings';
import { IdeasListAction } from '../IdeasList/actions';
import { PresetsAction } from '../Presets/actions';
import { UploadByLinkModalAction } from '../UploadByLinkModal/actions';
import { VideoCreativesAction } from '../VideoCreatives/actions';

import { CreativeType } from './typings';

export const changeCreativeType = createCustomAction(
    '@canvasEditor/CHANGE_CREATIVE_TYPE',
    type => (creativeType: CreativeType) => ({
        type,
        creativeType
    })
);

export type ChangeCreativeTypeAction = ReturnType<typeof changeCreativeType>;

export type CanvasAction =
    | IdeasListAction
    | PresetsAction
    | CommonCreativesAction
    | VideoCreativesAction
    | AddCreativeAction
    | UploadByLinkModalAction
    | GalleryAction
    | FileEditorAction
    | CreativeImageCropModalAction
    | CreativeSmartCenterModalAction
    | CanvasAppAction;

export type CanvasEditorAction = ItemNameEditorAction | CanvasAction | Html5Action | ChangeCreativeTypeAction;
